// importando estilização do componente

import { Styled } from './Styled';
import icons from '../../../../img/icons/icons';
import { useModal } from '../../../Contexts/Modal.context';
import { FullCurso } from '../FullCurso/FullCurso';
import { useEffect, useState } from 'react';
import { CoursesServices, ICourses } from '../../../Services/api/courses/courses.services';
import { IPicture, picturesServices } from '../../../Services/api/pictures/picturesServices';

interface IMiniCardCursoProps {
    id: string;
}

export const MiniCardCurso: React.FC<IMiniCardCursoProps> = ({ id }) => {
    const { openModal, closeModal } = useModal();
    const [course, setCourse] = useState<ICourses | null>(null);
    const [loading, setLoading] = useState(true);
    const [picture, setPicture] = useState<IPicture>();
    const NoIMG = icons.NoIMG;

    const clickMatricule = (CourseName: string) => {
        // abre coversa no whatsApp
        const phoneNumber = '55984544008'; // Substitua pelo número de telefone desejado
        const message = `Olá, tenho interesse em me matricular no curso ${CourseName}.`;
        const url = `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodeURIComponent(message)}`;
        window.open(url, '_blank');
    }

    useEffect(() => {
        const fetchCourse = async () => {
            setLoading(true);
            const result = await CoursesServices.getCourseById(id);
            if (!(result instanceof Error)) {
                setCourse(result);
                await picturesServices.getPictureByID(result.PictureId || '').then((result) => {
                    if (!(result instanceof Error)) {
                        setPicture(result);
                        console.log("picture url:", result.url);
                    } else {
                        setPicture(undefined);
                    }
                })
            } else {
                setCourse(null);
            }
            setLoading(false);
        };
        fetchCourse();
    }, [id]);

    const clickSeeMore = () => {
        openModal(<FullCurso id={id} onClose={closeModal} />);
    };

    if (loading) {
        return <Styled.Content>Carregando...</Styled.Content>;
    }

    if (!course) {
        return <Styled.Content>Erro ao carregar curso</Styled.Content>;
    }

    return (
        <Styled.Content>
            <span className='Title'>{course.Name}</span>
            <img src={picture ? `${picture.url}` : NoIMG} alt={course.Name} />
            <div className='ButtonsArea'>
                <button className='LeftButton' onClick={clickSeeMore}>Ver Mais</button>
                <button className='RightButton' onClick={() => clickMatricule(course.Name)}>Matricule-se</button>
            </div>
        </Styled.Content>
    );
};
// aqui estamos exportando nosso componente
